enum ContractProgressStep {
  PREVIEW = 'PREIVEW',
  FIELD_INSERT = 'FIELD_INSERT',
  ATTACHMENT = 'ATTACHMENT',
  AUTHENTICATION = 'AUTHENTICATION',
  COMPLETE = 'COMPLETE',
}

export default ContractProgressStep;
